<div class="row">
  <div class="col-12 mt-2">
    <p-dropdown [(ngModel)]="sizeChoice" [options]="sizeOfPages" (onChange)="pageSizeChange()" inputStyleClass="w-100" styleClass="dropdown-inforius">
    </p-dropdown>
  </div>
  <div class="col-12 h-100">
    <i-table
      [columns]="columns"
      [items]="mails"
      id="mailsTbl"
      height="calc(100vh - 50px )"
      [multiselect]="true"
      [paginator]="true"
      class="super-table"></i-table>
  </div>
</div>
